export enum AuthPage {
	MyWork = 'my-work',
	SiteNotes = 'site-notes',
	Deficiencies = 'deficiencies',
	ManageDocuments = 'manage-documents'
}
